var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "betslip-page pmbetslip-wrap",
        { loggedin: _vm.isLoggedIn },
        { bet_placed_sucessfuly: _vm.placeBetStatus == "P" }
      ]
    },
    [
      _vm.brandTemplate !== "generic_2" &&
      _vm.isLoggedIn &&
      _vm.placeBetStatus !== "P"
        ? _c(
            "div",
            { staticClass: "preheader" },
            [
              _c("div", { staticClass: "betslip_balance" }, [
                _c("span", { staticClass: "span_balance" }, [
                  _vm._v(_vm._s(_vm.$t("BetSlipPage.tab.balance")))
                ]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.balanceSum)))
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "close",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.toggleBetslip()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.brandTemplate !== "generic_2" && _vm.placeBetStatus !== "P"
        ? _c(
            "div",
            {
              staticClass: "betslip-page-header",
              class: { user_logged_in: _vm.isLoggedIn }
            },
            [
              _c("span", { staticClass: "tab active disabled" }, [
                _c(
                  "a",
                  { staticClass: "a-link-" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("Betslip.PM.Title")))]),
                    _c("badge", [_vm._v(_vm._s(_vm.selectedRunnersCount))])
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.brandTemplate === "generic_2" && _vm.placeBetStatus !== "P"
        ? _c(
            "div",
            {
              staticClass: "betslip-page-header",
              class: { user_logged_in: _vm.isLoggedIn }
            },
            [
              _c("span", { staticClass: "tab active disabled" }, [
                _c(
                  "a",
                  { staticClass: "a-link-" },
                  [
                    _c("badge", [_vm._v(_vm._s(_vm.selectedRunnersCount))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Betslip.PM.Title")) + "\n          "
                      ),
                      _c("div", { staticClass: "betslip_balance" }, [
                        _c("span", { staticClass: "span_balance" }, [
                          _vm._v(_vm._s(_vm.$t("BetSlipPage.tab.balance")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm._f("currency")(_vm.balanceSum)))
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.mobileBigAndBelow
                ? _c("span", {
                    staticClass: "betslip_down_icon",
                    on: {
                      click: function($event) {
                        return _vm.toggleBetslip()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobileBigAndBelow
                ? _c(
                    "a",
                    {
                      staticClass: "close",
                      on: {
                        click: function($event) {
                          return _vm.toggleBetslip()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BetSlip.tab.label.close")))]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.placeBetStatus == "P"
        ? _c(
            "div",
            { staticClass: "betslip-page-header pmBetPlaced" },
            [
              _c("span", { key: "your_receipt", staticClass: "your_receipt" }, [
                _vm._v(_vm._s(_vm.$t("BetSlip.status.placed.YourReceipt")))
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "close",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.dismissBetslip()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mobile_betslip",
          class: { pmBetPlaced: _vm.placeBetStatus == "P" }
        },
        [_c("betslip")],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54a1dfdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a1dfdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parimutuel/betting/BetslipMobile.vue
// module id = null
// module chunks = 